<template>
  <div class="goods">
    <div class="addbox">
      <el-button class="add-btn" icon="el-icon-plus" @click="add"
        >添加商品</el-button
      >
    </div>
    <div class="top">
      <div class="querybox">
        <div>
          <p>商品分类：</p>
          <el-select
            v-model="queryParams.goodsTypeOne"
            placeholder="请选择一级分类"
            @change="typeoneChange"
          >
            <el-option
              v-for="item in firstList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <span></span>
          <el-select
            v-model="queryParams.goodsTypeTwo"
            placeholder="请选择二级分类"
          >
            <el-option
              v-for="item in secondList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-popconfirm
            icon="el-icon-info"
            icon-color="red"
            title="确认删除选中的商品吗？"
            popper-class="customerdel-popover"
            @confirm="deleteFn()"
          >
            <el-button slot="reference" icon="el-icon-delete" class="add-btn"
              >删除</el-button
            >
          </el-popconfirm>
        </div>
      </div>
    </div>
    <div class="top">
      <div class="querybox">
        <div>
          <p>商品标题：</p>
          <el-input
            v-model="queryParams.name"
            placeholder="请输入商品标题"
            clearable
          ></el-input>
        </div>
        <div>
          <p>创建时间：</p>
          <!-- <el-date-picker
            v-model="value"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="timeChange"
          >
          </el-date-picker> -->
          <el-date-picker
            v-model="value"
            align="right"
            type="date"
            placeholder="选择时间"
            :picker-options="pickerOptions"
            @change="timeChange"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            class="reset-btn"
            @click="resetFn"
            >重置</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            class="search-btn"
            @click="search"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
        <el-table-column type="selection" width="65" fixed> </el-table-column>
        <el-table-column prop="cover" label="商品主图">
          <template slot-scope="{ row }">
            <div class="cover">
              <img :src="row.cover" alt="" />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="goodsTypeOneName"
          label="商品分类"
          min-width="150"
        >
          <template slot-scope="{ row }">
            {{ row.goodsTypeOneName }}/{{ row.goodsTypeTwoName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="商品标题"
          show-overflow-tooltip
          min-width="200"
        >
        </el-table-column>
        <el-table-column prop="showMoney" label="显示金额">
          <template slot-scope="{ row }"> ￥{{ row.showMoney }} </template>
        </el-table-column>
        <el-table-column prop="postage" label="邮费">
          <template slot-scope="{ row }"> ￥{{ row.postage }} </template>
        </el-table-column>
        <el-table-column prop="salesVolume" label="销量"> </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" min-width="150">
        </el-table-column>
        <el-table-column prop="isListed" label="状态">
          <template slot-scope="{ row }">
            <el-button
              :class="row.isListed === 0 ? 'success-btn' : 'fail-btn'"
              >{{ row.isListed === 0 ? "显示" : "下架" }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="120">
          <template slot-scope="scope">
            <el-popconfirm
              title="是否上架该商品？"
              popper-class="customerdel-popover"
              @confirm="cancelOrder(scope.row, 0)"
              v-if="Number(scope.row.isListed) === 1"
            >
              <el-button class="textOrange-btn" slot="reference"
                >上架</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              title="是否下架该商品？"
              popper-class="customerdel-popover"
              @confirm="cancelOrder(scope.row, 1)"
              v-if="Number(scope.row.isListed) === 0"
            >
              <el-button class="textOrange-btn" slot="reference"
                >下架</el-button
              >
            </el-popconfirm>
            <el-button
              class="textOrange-btn"
              @click="goEdit(scope.row)"
              style="margin-left: 10px"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
  </div>
</template>

<script>
import {
  getGoodsList,
  editGoodsStatus,
  deleteGoods,
  getClassifyList,
} from "@/api/shop";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        name: "",
        goodsTypeOne: "",
        goodsTypeTwo: "",
      },
      tableData: [],
      firstList: [],
      secondList: [],
      total: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      value: "",
      selectList: [],
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取消息公告列表
    async init() {
      const res = await getGoodsList(this.queryParams);
      const res1 = await getClassifyList({});
      this.tableData = res.result.records;
      this.firstList = res1.result;
      this.total = res.result.total;
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.name = "";
      this.queryParams.goodsTypeOne = "";
      this.queryParams.goodsTypeTwo = "";
      this.queryParams.startTime = "";
      this.queryParams.endTime = "";
      this.queryParams.pageNum = 1;
      this.value = "";
      this.init();
    },
    timeChange(event) {
      // console.log(event);
      if (event) {
        this.queryParams.startTime = this.$moment(event)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.queryParams.endTime = this.$moment()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      } else {
        this.queryParams.startTime = "";
        this.queryParams.endTime = "";
      }
      // console.log(this.queryParams);
    },
    async typeoneChange(value) {
      // console.log(value);
      const res = await getClassifyList({ parentId: value });
      this.secondList = res.result;
    },
    // 添加
    add() {
      this.$router.push({
        path: "/commodity",
        query: {
          type: "add",
        },
      });
    },
    // 编辑
    goEdit(item) {
      this.$router.push({
        path: "/commodity",
        query: {
          type: "edit",
          id: item.id,
        },
      });
    },
    //修改消息公告 状态
    async cancelOrder(item, isListed) {
      const params = {
        isListed,
        id: item.id,
      };
      await editGoodsStatus(params);
      // this.$refs[`${text}-popover-${index}`].doClose();
      this.init();
    },
    // 选择
    handleSelectionChange(val) {
      this.selectList = val.map((el) => {
        return el.id;
      });
    },
    // 删除
    async deleteFn() {
      if (this.selectList.length === 0) {
        this.$message.error("请先选择要删除的商品");
        return;
      }
      await deleteGoods(this.selectList);
      this.$message.success("删除成功");
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.goods {
  position: relative;
  .addbox {
    position: absolute;
    top: -88px;
    right: 0;
  }
  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    ::v-deep .querybox {
      display: flex;
      align-items: center;

      > div {
        display: flex;
        align-items: center;
        margin-right: 24px;
        > span {
          display: block;
          width: 15px;
          height: 1px;
          background: #979797;
          margin: 0 6px;
        }
        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
        }
        .el-input,
        .el-range-editor {
          width: 216px;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(0, 0, 0, 0.25);
        }
        .el-input__inner {
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
      }
    }
    .handlebox {
      display: flex;
      align-items: center;
    }
  }
  .content {
    .cover {
      display: flex;
      justify-content: center;
      width: 44px;
      height: 44px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
    // .textOrange-btn {
    //   margin: 0 10px;
    // }
  }
  ::v-deep .is-checked {
    .el-checkbox__inner {
      background-color: #ff5d2f;
      border-color: #ff5d2f;
    }
  }
  ::v-deep .is-indeterminate {
    .el-checkbox__inner {
      background-color: #ff5d2f;
      border-color: #ff5d2f;
    }
  }
}
</style>
